export const MAP_ZOOM_CONTROL = {
  WORLD: 1,
  CONTINENT: 5,
  CITY: 10,
  STREETS: 15,
  BUILDINGS: 20,
} as const

export const MIN_ZOOM_LEVEL = 5

export const MAP_CIRCLE_RADIUS_IN_METRES = 550
